<app-modal title="Your Order Summary">
  <section class="marTop40">
    <div class="dFlex alignItemsCenter">
      <div class="serviceDetails weglot-allowed">
        <h2 class="greenT w400">{{ data.service?.name || tierSelected?.name }}</h2>
        <p class="darkGreyT tAlignLeft fs-1 marRight20" *ngIf="data.service">{{ data.service.description }}</p>
        <ul class="darkGreyT tAlignLeft fs-1 marRight20" *ngIf="tierSelected?.tierLevel === 'essentials'">
          <li>100% satisfaction guarantee</li>
          <li>Included all required forms</li>
          <li>Option to print application at home</li>
          <li>Live chat support</li>
          <li>Comprehensive application review by immigration attorney</li>
          <li>Translation of required documents</li>
        </ul>
        <ul class="darkGreyT tAlignLeft fs-1 marRight20" *ngIf="tierSelected?.tierLevel === 'enhanced'">
          <li>Everything in Essentials</li>
          <li>Translation of 5 additional pages to include in your application (if needed)</li>
          <li>Ready-to-submit application mailed to your home</li>
          <li>Legal support if USCIS requests additional evidence</li>
          <li>Extended support from assigned Case Manager until approval</li>
          <li>One consultation with an immigration attorney to answer questions</li>
        </ul>
        <ul class="darkGreyT tAlignLeft fs-1 marRight20" *ngIf="tierSelected?.tierLevel === 'professional'">
          <li>Everything in Enhanced</li>
          <li>One consultation with an immigration attorney to discuss your application review</li>
          <li>One consultation with an immigration attorney to prepare you for your interview</li>
          <li>USCIS Interview Preparation Kit delivered to your door</li>
          <li>Two-day express shipping of your application</li>
        </ul>
      </div>
      <div class="price marLeft20">
        <p class="medGreyT tAlignLeft fs-1">
          Order Total: <span class="primaryT">{{ price | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        </p>
      </div>
    </div>

    <hr class="marTop40 opat25" />

    <section class="marTop40 tAlignLeft" *ngIf="data.appCase">
      <p>
        Selected Case: {{ data.appCase.application?.name }} <small>({{ data.appCase.id }})</small>
      </p>
    </section>

    <section class="marTop40" *ngIf="!data.appCase && data.cases">
      <label class="oneColumn tAlignLeft">
        <select
          [(ngModel)]="caseSelected"
          [required]="true"
          class="radius field darkWhiteBG50"
          [class.is-empty]="!caseSelected"
          (ngModelChange)="checkPriceAndLoadElements()"
        >
          <option [ngValue]="appCase" *ngFor="let appCase of data.cases">
            {{ appCase?.application?.applicationType?.name }}
          </option>
        </select>
        <span class="medGreyT"
          ><span>Select a case you need service for: <strong class="required">*</strong></span></span
        >
      </label>
    </section>

    <section class="marTop40" *ngIf="data.appCase && data.tiers">
      <label class="oneColumn tAlignLeft">
        <select
          [(ngModel)]="tierSelected"
          [required]="true"
          class="radius field darkWhiteBG50"
          [class.is-empty]="!tierSelected"
          (ngModelChange)="checkPriceAndLoadElements()"
        >
          <option [ngValue]="tier" *ngFor="let tier of data.tiers">{{ tier.tierLevel | titlecase }}</option>
        </select>
        <span class="medGreyT"
          ><span>Select an upgrade package: <strong class="required">*</strong></span></span
        >
      </label>
    </section>

    <hr class="marTop40 opat25" />

    <section class="marTop40 marBot40 tAlignLeft">
      <p class="marBot40">Provide your payment information</p>
      <div class="dFlex">
        <label class="flex1 marRight20">
          <input
            type="text"
            id="promoCode"
            name="promoCode"
            class="radius field darkWhiteBG50"
            [class.is-empty]="!promoCode"
            (keyup)="promoCodeFetched = false"
            (blur)="checkPromo()"
            [(ngModel)]="promoCode"
            [class.is-not-valid]="promoCode && promoCodeFetched && !promoCodeValid"
          />
          <span class="medGreyT"><span>Promo code</span></span>
        </label>

        <button
          class="button primary radius dropShadow noMin normWeight noMarTop noMarRight noMarLeft"
          type="button"
          [disabled]="!promoCode && !promoCodeDescription"
          (click)="checkPromo()"
        >
          <fa-icon [icon]="['far', 'angle-double-left']"></fa-icon> Apply
        </button>
      </div>

      <p class="promo found" *ngIf="promoCodeDescription">
        <fa-icon class="greenT marRight20 fs-175" [icon]="['fas', 'circle-check']"></fa-icon>
        {{ promoCodeDescription }} applied.
      </p>
      <p class="promo notFound" *ngIf="promoCodeError">
        <fa-icon class="marRight20 fs-175" [icon]="['fas', 'octagon-xmark']"></fa-icon>
        {{ promoCodeError }}
      </p>

      <h6 *ngIf="price !== 0" class="paymentTitle locked relative marTop40 marBot10 darkGreyT w300 tAlignCenter">
        Secure Credit Card Payment Information
        <span class="dBlock"><span>This is a secure 256-bit SSL encrypted payment.</span></span>
      </h6>
    </section>

    <form id="payment-form" class="overflowXHidden">
      <div id="payment-element" *ngIf="price !== 0">
        <!--Stripe.js injects the Payment Element-->
      </div>

      <p *ngIf="price !== 0" class="marTop40 fs-875 tAlignLeft">
        By providing your card information, you allow SimpleCitizen, Inc. to charge your card for future payments in
        accordance with their terms.
      </p>
      <div class="marTop40 fs-875 tAlignLeft">
        <input type="checkbox" id="stripe-terms" [formControl]="terms" />
        <label for="stripe-terms"
          >I agree to the
          <a
            class="w700 clickable underlineHover"
            href="https://www.simplecitizen.com/terms-and-conditions/"
            target="_blank"
            >SimpleCitizen Terms and Conditions</a
          ></label
        >
      </div>

      <div id="payment-message" class="hidden"></div>
    </form>

    <p class="promo notFound" *ngIf="checkPriceError">
      <fa-icon class="marRight20 fs-175" [icon]="['fas', 'octagon-xmark']"></fa-icon>
      {{ checkPriceError }}
    </p>

    <p class="notFound" *ngIf="paymentError">
      <fa-icon class="marRight20 fs-175" [icon]="['fas', 'octagon-xmark']"></fa-icon>
      {{ paymentError }}
    </p>

    <p *ngIf="paymentSuccessful" class="found">
      <fa-icon class="greenT marRight20 fs-175" [icon]="['fas', 'circle-check']"></fa-icon>
      Payment successful.
    </p>

    <div class="actionBtnContainer">
      <button class="actionBtn w400 marTop20" type="button" (click)="close()">Cancel</button>

      <button
        class="actionBtn w400 marTop20"
        type="button"
        (click)="submitPayment($event)"
        [disabled]="paymentButtonDisabled"
      >
        Complete Purchase
      </button>
    </div>
  </section>
</app-modal>
